<template lang="pug">
  Sidebar

    div.d-flex.justify-content-end.align-items-center.custom-sidebar
      SidebarHeader.flex-fill
        template
          div.d-flex.justify-content-end
            div.p-1.align-self-center.flex-fill.text-left
              span {{ $store.getters.displayName }}
            b-link.align-self-center(to="/system/setting" v-b-tooltip.hover :title="$t('ui.settings')").mr-1
              i.p-1.fa.fa-sliders-h
            b-link.align-self-center(to="/logout" v-b-tooltip.hover :title="$t('ui.logout')")
              i.p-1.fa.fa-sign-out-alt
      SidebarMinimizer(@cui-sidebar-minimize="handleMinimized")
    SidebarNav(:navItems="navItems")
    //- SidebarMinimizer(@cui-sidebar-minimize="handleMinimized")
</template>

<script>
import config from "@/config";
import { Sidebar, SidebarHeader, SidebarNav, SidebarMinimizer } from "@/library/coreui";

export default {
  components: {
    Sidebar,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  computed: {
    navItems() {
      return [
        {
          name: this.$t("ui.account"),
          icon: "fa fa-users",
          pages: [config.accessRoles.account],
          children: [
            {
              name: this.$tc("ui.account_list", 2),
              url: "/account/account_list",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.account]
            },
            {
              name: this.$t("ui.ibank_list"),
              url: "/account/ibank_list",
              icon: "fa fa-university",
              pages: [config.accessRoles.account]
            }
          ]
        },
        {
          divider: true
        },
        {
          name: this.$t("ui.promotion"),
          icon: "fas fa-gift",
          pages: [config.accessRoles.promotion],
          children: [
            {
              name: this.$tc("ui.promotion_list", 2),
              url: "/promotion/promotion_list",
              icon: "fas fa-th-list",
              pages: [config.accessRoles.promotion]
            },
            {
              name: this.$t("ui.package_list"),
              url: "/promotion/package_list",
              icon: "fas fa-th-list",
              pages: [config.accessRoles.promotion]
            }
          ]
        },
        {
          divider: true
        },
        // {
        //   name: this.$t("ui.survey"),
        //   icon: "fas fa-comments",
        //   pages: [config.accessRoles.survey],
        //   children: [
        //     {
        //       name: this.$t("ui.survey_list"),
        //       url: "/survey/survey_list",
        //       icon: "fas fa-comments",
        //       pages: [config.accessRoles.survey]
        //     }
        //   ]
        // },
        {
          divider: true
        },
        {
          name: this.$t("ui.report"),
          icon: "fas fa-chart-line",
          pages: [config.accessRoles.report],
          children: [
            {
              name: this.$t("ui.daily_statement"),
              url: "/report/daily_statement",
              icon: "fas fa-chart-line",
              pages: [config.accessRoles.report]
            },
            {
              name: this.$t("ui.daily_winlose"),
              url: "/report/daily_winlose",
              icon: "fas fa-chart-line",
              pages: [config.accessRoles.report]
            },
            {
              name: this.$t("ui.game_result_slots"),
              url: "/report/game_result_slots",
              icon: "fas fa-th-list",
              pages: [config.accessRoles.report]
            }
          ]
        },
        {
          divider: true
        },
        {
          name: this.$t("ui.system"),
          icon: "fa fa-desktop",
          pages: [config.accessRoles.function, config.accessRoles.page, config.accessRoles.role, config.accessRoles.user],
          children: [
            {
              name: this.$tc("ui.functions", 2),
              url: "/system/function",
              icon: "fas fa-cube",
              pages: [config.accessRoles.function]
            },
            {
              name: this.$tc("ui.pages", 2),
              url: "/system/page",
              icon: "far fa-file",
              pages: [config.accessRoles.page]
            },
            {
              name: this.$tc("ui.roles", 2),
              url: "/system/role",
              icon: "fa fa-id-card",
              pages: [config.accessRoles.role]
            },
            {
              name: this.$tc("ui.users", 2),
              url: "/system/user",
              icon: "fa fa-users-cog",
              pages: [config.accessRoles.user]
            }
          ]
        },
        {
          divider: true
        }
      ];
    }
  },
  methods: {
    handleMinimized(e) {
      // console.log("minimized", e);
      this.$store.dispatch("layout/setSidebarMinimized", e);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-sidebar {
    background: rgba(0, 0, 0, 0.4);
    -webkit-box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);
    box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);
    .sidebar-header {
      background: transparent;
      box-shadow: none;
    }

}
</style>
